import { render, staticRenderFns } from "./salesPersonTable.vue?vue&type=template&id=4a464772&"
import script from "./salesPersonTable.vue?vue&type=script&lang=js&"
export * from "./salesPersonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports